import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'preference',
  templateUrl: './preference.component.html',
  styleUrls: ['./preference.component.scss']
})
export class PreferenceComponent implements OnInit {
  @Input() label: string = '';
  @Input() description: string = '';

  constructor() { }

  ngOnInit() {
  }

}
